import React from 'react';
import { UrgentCTA } from './UrgentCTA';
import { ClockIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-gradient-to-b from-pink-50 via-white to-amber-50 py-12 md:py-20 px-4" data-id="element-67">
      <div className="container mx-auto max-w-5xl" data-id="element-68">
        {/* Urgent Badge */}
        <div className="flex justify-center mb-6 md:mb-8" data-id="element-69">
          <div className="inline-flex items-center gap-2 bg-pink-500 text-white px-6 py-3 rounded-full border-4 border-pink-600 shadow-2xl animate-pulse-urgent" data-id="element-70">
            <ClockIcon className="w-5 h-5 md:w-6 md:h-6 animate-shake" aria-hidden="true" data-id="element-71" />
            <span className="font-extrabold text-sm md:text-base uppercase tracking-wider" data-id="element-72">
              OFERTA TERMINA EN 10 MINUTOS
            </span>
          </div>
        </div>

        {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-pink-600 text-center mb-4 md:mb-6 leading-tight" data-id="element-73">
          ¿Cansada de no tener suficiente dinero a fin de mes?
        </h1>
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-rose-500 text-center mb-6 md:mb-8 leading-tight" data-id="element-74">
          Descubre cómo mujeres como tú están generando ingresos REALES desde
          casa
        </h2>

        {/* Product Image */}
        <div className="flex justify-center mb-8 md:mb-12" data-id="element-75">
          <img src="https://cdn.magicpatterns.com/uploads/fYvhVkJvZQ1E9jU68AqtVs/2.jpg" alt="Placas aromáticas artesanales con flores secas, lavanda y rodajas de naranja" className="rounded-2xl shadow-2xl max-w-full md:max-w-2xl border-4 border-pink-200" data-id="element-76" />
        </div>

        {/* Subheadline */}
        <p className="text-lg md:text-2xl text-stone-700 text-center mb-8 md:mb-12 max-w-3xl mx-auto font-bold" data-id="element-77">
          Aprende a hacer Placas Aromáticas Artesanales en menos de 24 horas y
          empieza a vender un producto que la gente AMA
        </p>

        {/* CTA */}
        <div className="max-w-2xl mx-auto" data-id="element-78">
          <UrgentCTA size="large" data-id="element-79">🔥 QUIERO ACCESO INMEDIATO 🔥</UrgentCTA>
          <p className="text-center text-sm md:text-base text-stone-600 mt-4 font-bold" data-id="element-80">
            ⚡ Acceso instantáneo • Sin riesgos
          </p>
        </div>
      </div>
    </section>;
}